import { render, staticRenderFns } from "./EditUserInfo.vue?vue&type=template&id=36250808&scoped=true"
import script from "./EditUserInfo.vue?vue&type=script&lang=js"
export * from "./EditUserInfo.vue?vue&type=script&lang=js"
import style0 from "./EditUserInfo.vue?vue&type=style&index=0&id=36250808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36250808",
  null
  
)

export default component.exports